import React, {useEffect, useState} from 'react';
import MindsetsJsSDK, {DateRangeSelector} from "mindsets-js-sdk";

export default function({
    selectedDistrictId,
    setSelectedDistrictId,
    selectedSchoolId,
    setSelectedSchoolId,
    selectedFrom,
    setSelectedFrom,
    selectedTill,
    setSelectedTill
}) {

    const [districts, setDistricts] = useState([]);
    const [schools, setSchools] = useState([]);

    function loadData() {
        MindsetsJsSDK().API.get(`dashboards/super/select`, {
            district_id: selectedDistrictId,
            school_id: selectedSchoolId
        }).then((response) => {
            if (response.districts) {
                setDistricts(response.districts);
            }

            if (response.schools) {
                setSchools(response.schools);
            }
        });
    }

    useEffect(() => {
        loadData();
    }, [selectedDistrictId, selectedSchoolId]);
    
    const districtSelect = () => {
        const onChange = (e) => {
            setSelectedDistrictId(e.target.value);
            setSelectedSchoolId(0);
        }

        const renderOptions = () => {
            return districts.map((d, k) => {
                return (
                    <option key={d.id} value={d.id}>{d.name}</option>
                );
            });
        }

        return (
            <div className="flex-row flex-v-center flex-gap-10">
                <div>
                    {`District:`}
                </div>
                <div className="district-select">
                    <select value={selectedDistrictId} onChange={onChange}>
                        <option value={0}>{`Select a District`}</option>
                        {renderOptions()}
                    </select>
                </div>
            </div>
        );
    }

    const schoolSelect = () => {
        const onChange = (e) => {
            setSelectedSchoolId(e.target.value);
        }

        const renderOptions = () => {
            return schools.map((s, k) => {
                if (!s.id) {
                    return null;
                }

                return (
                    <option key={s.id} value={s.id}>{s.name}</option>
                );
            });
        }

        return (
            <div className="flex-row flex-v-center flex-gap-10">
                <div>
                    {`School:`}
                </div>
                <div className="school-select">
                    <select value={selectedSchoolId} onChange={onChange}>
                        <option value={0}>{`All Schools`}</option>
                        {renderOptions()}
                    </select>
                </div>
            </div>
        );
    }

    const dateSelect = () => {
        const onUpdate = (data) => {
            setSelectedFrom(data.from)
            setSelectedTill(data.till)
        }

        return (
            <div className="flex-row flex-v-center flex-gap-10">
                <div>
                    {`Date:`}
                </div>
                <DateRangeSelector
                    from={selectedFrom}
                    till={selectedTill}
                    onUpdate={onUpdate}
                    as={'selector'}
                    trigger_class='like-selector'
                />
            </div>
        );
    }

    return (
        <div className="flex-row flex-gap-20">
            {districtSelect()}
            {schoolSelect()}
            {dateSelect()}
        </div>
    );
}